import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class FileReaderService {
  constructor(
    private readonly toastr: ToastrService
  ) { }

  public async getFile(): Promise<object>{
    var input = document.createElement('input');
    input.type = 'file';
    var file: File;
    input.click();
    return await new Promise<object>((resolve) => {
      input.onchange = e => {
        const target = event?.target as HTMLInputElement;
        file = (target.files as FileList)[0];
        if (!file) {
          this.toastr.error('No file selected');
          resolve({});

        }
        resolve(this.readFileContent(file));
      }
    })
  }

  private async readFileContent(file?: File): Promise<object> {
    let fileReader = new FileReader();

    return await new Promise<object>((resolve) => {
      if (!file) {
        resolve({});
      }
      fileReader.onload = () => {
        const text = JSON.parse(fileReader.result!.toString());
        resolve(text.data.attributes);
      }
      fileReader.readAsText(file!);
    })
  }
}
